"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BlogCard1;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.string.replace.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function BlogCard1(props) {
  const [listItems, setListItems] = (0, _react.useState)(props.list || []);
  (0, _react.useEffect)(() => {
    var _props$list;

    if (props.maxItems && props !== null && props !== void 0 && (_props$list = props.list) !== null && _props$list !== void 0 && _props$list.length) {
      setListItems(props.list.slice(0, props.maxItems));
    }
  }, [props.maxItems]);

  const onItemClick = index => {
    if (!props.isSourceWebConsole) {
      const link = window.location.href.split("");
      const ifLastCharSlash = link[link.length - 1] === "/";
      if (props.slug) window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/", "p/").concat(props.slug, "/").concat(index);else window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/").concat(index);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: "users_list",
    className: "flex flex-wrap justify-center blog-card-main-container"
  }, !!listItems && (listItems === null || listItems === void 0 ? void 0 : listItems.map((item, index) => {
    var _item$image, _item$heading, _item$heading2, _item$description;

    return /*#__PURE__*/_react.default.createElement("div", {
      id: item.id,
      key: index,
      className: "list-card list-card-blog w-100-l flex flex-column relative ".concat(!props.isSourceWebConsole && "pointer"),
      onClick: () => onItemClick(index)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-column items-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "blog-image flex items-center justify-center relative"
    }, item !== null && item !== void 0 && (_item$image = item.image) !== null && _item$image !== void 0 && _item$image.url ? /*#__PURE__*/_react.default.createElement("img", {
      id: item.id + "_" + "image",
      src: item.image.url,
      className: "card-image"
    }) : null, item !== null && item !== void 0 && item.date ? /*#__PURE__*/_react.default.createElement("div", {
      className: "date-box f5 flex flex-column justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "f3 fw6"
    }, item === null || item === void 0 ? void 0 : item.date.selected_date), /*#__PURE__*/_react.default.createElement("div", {
      className: "month-selected"
    }, item === null || item === void 0 ? void 0 : item.date.selected_month)) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "w-100 card-body"
    }, item !== null && item !== void 0 && (_item$heading = item.heading) !== null && _item$heading !== void 0 && _item$heading.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "blog-heading",
      className: "mb2 f4 fw7"
    }, item === null || item === void 0 ? void 0 : (_item$heading2 = item.heading) === null || _item$heading2 === void 0 ? void 0 : _item$heading2.display_text) : null, item !== null && item !== void 0 && (_item$description = item.description) !== null && _item$description !== void 0 && _item$description.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "blog-body",
      className: "pb4"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "f5 o-50 card-body__text"
    }, item === null || item === void 0 ? void 0 : item.description.display_text.replace(/<[^>]*>/g, '').slice(0, 150), "... "), " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "fw6 f5 underline-hover pointer"
    }, "Read Full Blog")) : null)), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex flex-column justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: ""
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/blackedit.png"
    }), "Edit"), /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: "",
        operation: "delete"
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove")));
  })), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-card add-new-card-blog flex flex-column items-center justify-center pointer",
    onClick: () => props.onWrapperClick({
      parentKey: "users_list",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "plus-sign"
  }, "+"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, "Add New")));
}